import { Assignee, Role, TicketUser } from './Auth';
import { DateRange, Stat } from './Stats';

export enum TicketStatus {
  UNASSIGNED = 'unassigned',
  TO_DO = 'to_do',
  IN_PROGRESS = 'in_progress',
  RESOLVED = 'resolved',
}

export enum TicketRepairMethod {
  REMOTE = 'remote',
  IN_PERSON = 'in_person',
}

export interface TicketNote {
  createdAt: string;
  id: string;
  portalUserId: string;
  text: string;
  ticketId: number;
}

export interface BaseTicket {
  id?: number;
  ticketId?: string;
  prefix: string;
  status: TicketStatus;
  unitId: string;
  model: string;
  createdAt: string;
  assignedAt?: string;
  startedAt?: string;
  resolvedAt?: string;
}

export interface Ticket extends BaseTicket {
  manufacturerId: string;
  portalUserId: string;
  assigneeId: string;
  user: TicketUser;
  assignee?: Assignee;
  text: string;
  checkUpDate?: string;
}

export interface ListTicket extends BaseTicket {
  address: string;
  assignee?: Assignee;
  owner: string;
  lat?: string;
  lon?: string;
}

export type MapFilter = {
  [key in TicketStatus]: boolean;
};

export interface MapCheckboxes {
  [Role.ADMIN]: TicketCheckbox[];
  [Role.MANUFACTURER]: TicketCheckbox[];
  [Role.SERVICE]: TicketCheckbox[];
}

export interface TicketCheckbox {
  label: string;
  color:
    | 'info'
    | 'error'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'default';
  name: TicketStatus;
}

export interface TicketStatistics {
  range: DateRange;
  before: Stat[];
  current: Stat[];
}
